const isObject = (value: unknown): value is Record<string, unknown> =>
    value !== null && typeof value === "object" && !Array.isArray(value);

export const deepEqual = (left: unknown, right: unknown): boolean => {
    if (Number.isNaN(left) && Number.isNaN(right)) return true;
    if (left === right) return true;

    if (left instanceof Date || right instanceof Date) {
        return left instanceof Date && right instanceof Date && left.getTime() === right.getTime();
    }

    if (Array.isArray(left) || Array.isArray(right)) {
        if (!Array.isArray(left) || !Array.isArray(right) || left.length !== right.length) return false;
        for (let i = 0; i < left.length; i += 1) {
            if (!deepEqual(left[i], right[i])) return false;
        }
        return true;
    }

    if (isObject(left) || isObject(right)) {
        if (!isObject(left) || !isObject(right)) return false;
        const leftKeys = Object.keys(left);
        const rightKeys = Object.keys(right);
        if (leftKeys.length !== rightKeys.length) return false;
        for (const key of leftKeys) {
            if (!Object.prototype.hasOwnProperty.call(right, key)) return false;
            if (!deepEqual(left[key], right[key])) return false;
        }
        return true;
    }

    return false;
};
